// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ghsinfodetail {\n  padding-bottom: 10px !important;\n  margin-top: -20px;\n}", ""]);
// Exports
module.exports = exports;
